/*
	import { addBoardPackageDocument } from '@/services/BoardMeetings/BoardPackageDocument/Post';

  const boardPackageDocument = await addBoardPackageDocument ({
    json: {
      "hoaID": hoaID,
      boardPackageID: 45,

      // "documentID": 0,
      "layoutDocumentSourceID": 2,
      "layoutAvailabilityID": 1,
      // "sortOrder": 0,
      // "documentName": "string",

      "documentName": "name of the document",  
      
    }
  }).then (({ successful, message, boardPackageDocument }) => {
    if (!successful) {
      throw message;
    }

    return boardPackageDocument
  });
*/

/*
  exception.fields {
    phoneNumber: [ '' ],    
  }
*/
//
//
//
import kms from '@/services/kms'
//
import { notifyError } from '@/services/notify'
//
export async function addBoardPackageDocument({ json }) {
  let exception = ''

  try {
    const result = await kms.post(`/BoardMeetings/BoardPackageDocument`, json)

    return {
      successful: true,
      message: 'The board meeting document was added successfully.',
      exception: null,
      boardPackageDocument: result
    }
  } catch (_exception) {
    exception = _exception
  }

  let message = 'The board meeting document could not be added.'
  notifyError(message)

  return {
    successful: false,
    message,
    exception,
    boardPackageDocument: null
  }
}
